export const USER_AUTH_SLICE = "userAuthSlice";
export interface UserAuth {
  _id: string;

  fullName: string;
  role: string;
  token: string;
}
export interface UserAuthSlice<UserAuth> {
  data: UserAuth | null;
  loading: boolean;
}
export interface IDataUserLocalStorage {
  token: string;
}
export const PRE_ACTION_ACCOUNT_URL = "accounts";

export const PRE_ACTION_AUTHENTICATION_URL = "auth";
